import { gql } from 'apollo-boost';

export const newNotificationRecipient = gql`
mutation newNotificationRecipient(
  $rule: Int!
  $email: String,
  $userId: Int,
) {
newNotificationRecipient(
  rule: $rule,
  email: $email,
  userId: $userId,
) {
    success
    id
  }
}
`;
